import clsx from "clsx";
import React from "react";
import { Box, Typography, Card } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { QrCode } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: theme.spacing(2),
    overflow: "hidden",
    boxShadow: theme.shadows[1],
    border: `2px dashed ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    minHeight: theme.spacing(56),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
  },

  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    maxWidth: theme.spacing(40),
  },

  icon: {
    fontSize: theme.spacing(8),
    color: theme.palette.action.disabled,
    marginBottom: theme.spacing(2),
  },

  title: {
    fontSize: 18,
    fontWeight: 700,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },

  subtitle: {
    fontSize: 14,
    color: theme.palette.text.disabled,
  },
}));

export interface ProgramInvitePlaceholderProps {
  className?: string;
}

export function ProgramInvitePlaceholder(props: ProgramInvitePlaceholderProps) {
  const { className } = props;
  const s = useStyles();

  return (
    <Card className={clsx(s.root, className)} elevation={0}>
      <Box className={s.content}>
        <QrCode className={s.icon} />
        <Typography className={s.title}>No program selected</Typography>
        <Typography className={s.subtitle}>
          Enter a valid invite code to preview the program details
        </Typography>
      </Box>
    </Card>
  );
}
